export const tokens = {
  colors: {
    // Fondo base
    bg0: "#0B2B46",      // azul profundo
    bg1: "#0E3658",      // azul medio
    bg2: "#103E67",      // azul para secciones

    // Superficies (cards)
    surface: "rgba(255,255,255,0.06)",
    surface2: "rgba(255,255,255,0.10)",
    border: "rgba(255,255,255,0.10)",

    // Texto
    text: "rgba(255,255,255,0.92)",
    muted: "rgba(255,255,255,0.62)",

    // Acentos (como el amarillo de botones)
    primary: "#F2B84B",
    primary2: "#F7D07A",

    // Estado
    error: "#FF5A79",
    success: "#5DE2B1",
  },

  radius: {
    xl: 28,
    lg: 22,
    md: 16,
    sm: 12,
    pill: 999,
  },

  // Neumorphism: sombra exterior + sombra interior (inset)
  shadow: {
    // sombra suave tipo iOS
    soft: "0 18px 40px rgba(0,0,0,0.35)",
    // relieve externo (arriba/izq claro + abajo/der oscuro)
    neumorph: `
      10px 10px 26px rgba(0, 0, 0, 0.38),
      -10px -10px 26px rgba(255, 255, 255, 0.06)
    `,
    // relieve interno para inputs
    inset: `
      inset 10px 10px 18px rgba(0,0,0,0.35),
      inset -10px -10px 18px rgba(255,255,255,0.05)
    `,
  },
};
